import Spacer from '@/common/components/spacer';
import { getDynamicCurrency } from '@/util-conversion/currency';
import SavingsGradientText from './savings-gradient-text';
import { useState } from 'react';
import SavingsCalculatorV2UpfrontCostInfoDrawerDialog from './savings-calculator-v2-upfront-cost-info-drawer-dialog';

interface SavingsCostComparisonProps {
  buyingUpfront: number;
  buyingMonthlyCar: number;
  buyingMonthlyInsurance: number;
  flexcarUpfront: number;
  flexcarMonthlyCar: number;
  flexcarMonthlyInsurance: number;
  flexcarShippingCost?: number;
  flexcarNewCarSurcharge?: number;
  flexcarMembershipCost?: number;
}

export default function SavingsCostComparisonTable({
  buyingUpfront,
  buyingMonthlyCar,
  buyingMonthlyInsurance,
  flexcarUpfront,
  flexcarMonthlyCar,
  flexcarMonthlyInsurance,
  flexcarShippingCost,
  flexcarNewCarSurcharge,
  flexcarMembershipCost,
}: SavingsCostComparisonProps) {
  const [isUpfrontCostDetailsModalOpen, setIsUpfrontCostDetailsModalOpen] =
    useState(false);

  const closeUpfrontCostDetailsModal = () => setIsUpfrontCostDetailsModalOpen(false);

  return (
    <>
      <div className="flex w-full justify-between gap-[32px] sm:justify-center">
        {/* Cost labels column */}
        <div className="flex flex-col gap-[12px] py-[12px]">
          {/* Empty space for alignment */}
          <Spacer variant="height24" />
          <div className="flex flex-col gap-[8px]">
            <p className="caption-regular mt-[4px] tracking-[0.02em]">UPFRONT</p>
            <p className="caption-regular mt-[4px] tracking-[0.02em]">CAR</p>
            <p className="caption-regular mt-[4px] tracking-[0.02em]">INSURANCE</p>
          </div>
        </div>

        {/* Buying costs column */}
        <div className="flex flex-col gap-[12px] py-[12px]">
          <p className="body-strong tracking-[-0.005em]">BUYING</p>
          <div className="flex flex-col gap-[8px]">
            <p className="body2">{getDynamicCurrency(buyingUpfront)}</p>
            <p className="body2">{getDynamicCurrency(buyingMonthlyCar)}/mo</p>
            <p className="body2">{getDynamicCurrency(buyingMonthlyInsurance)}/mo</p>
          </div>
        </div>

        {/* Flexcar costs column */}
        <div className="rounded-xl bg-[linear-gradient(37.15deg,_#71D9D5_-10.58%,_#D2C6F7_80.75%,_#F9DCDB_116.15%)] p-[1px]">
          <div className="flex flex-col gap-[12px] rounded-xl bg-white px-[16px] py-[12px]">
            <p className="font-heading font-medium tracking-[-0.005em] text-flexcar-blue30">
              FLEXCAR
            </p>
            <div className="flex flex-col gap-[8px]">
              <div className="flex flex-row items-center gap-[4px]">
                <SavingsGradientText
                  savingsNumber={flexcarUpfront}
                  className="leading-[20px]"
                />
              </div>
              <SavingsGradientText
                savingsNumber={flexcarMonthlyCar}
                savingsSuffix="/mo"
                className="leading-[20px]"
              />
              <SavingsGradientText
                savingsNumber={flexcarMonthlyInsurance}
                savingsSuffix="/mo"
                className="leading-[20px]"
              />
            </div>
          </div>
        </div>
      </div>

      {isUpfrontCostDetailsModalOpen ? (
        <SavingsCalculatorV2UpfrontCostInfoDrawerDialog
          open={isUpfrontCostDetailsModalOpen}
          handleClose={closeUpfrontCostDetailsModal}
          flexcarNewCarSurcharge={flexcarNewCarSurcharge}
          flexcarShippingCost={flexcarShippingCost}
          flexcarMembershipCost={flexcarMembershipCost}
        />
      ) : null}
    </>
  );
}
